export async function fetchTeams(baseURL: string) {
  try {
    const request = await fetch(baseURL + '/sps/listteams', {
      method: 'GET',
      // mode: 'no-cors',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
      },
    });

    const json = await request.json();

    if (json === 'sesout') {
      throw new Error('Session timeout');
    }

    if (json && json.teams && Array.isArray(json.teams)) {
      return json.teams;
    }
  } catch (e) {
    console.log(e);
  }
}
